import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  
  constructor(private translate: TranslateService) {
    // Définir la langue par défaut
    this.translate.setDefaultLang('fr');
    this.translate.use('fr');
  }
}